<template>
  <section class="solutions container">
    <h2>{{ $t('nav.products_solutions') }}</h2>

    <div class="solution-list">
      <div
        v-for="(item, index) in $t('home.solutions.list', { returnObjects: true })"
        :key="index"
        class="solution-card"
      >
        <div class="solution-info" @click="goDetail(item.url)">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>

          <el-tag
            v-for="(device, dIdx) in item.devices"
            :key="dIdx"
            type="info"
            class="device-tag"
          >
            {{ device }}
          </el-tag>
        </div>

        <div class="solution-img">
          <img :src="require(`@/assets/images/devices/${item.img}`)" :alt="item.title" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Solutions",
  methods: {
    goDetail(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style scoped>
.solutions {
  max-width: 1200px;
  margin: 0 auto;
}

.solution-list {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.solution-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s;
}

.solution-card:hover {
  transform: translateY(-4px);
}

.solution-info {
  flex: 1;
  cursor: pointer;
}

.solution-info h3 {
  font-size: 22px;
  margin-bottom: 10px;
  color: #333;
}

.solution-info p {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

.solution-img {
  width: 300px;
  text-align: right;
}

.solution-img img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
}

.device-tags {
  margin-top: 8px;
}

.device-tag {
  margin-right: 8px;
  margin-bottom: 4px;
}
</style>
